import React from "react";
import { observer } from "owa-mobx-react";
import { getStore } from "../store/store";

/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function getStore called at module scope is not allowed. This may cause unwanted side effects. */
const store = getStore();

export const DialogHost: React.FunctionComponent = observer(() => {
    return <div>{Array.from(store.dialogs.values())}</div>;
}, "DialogHost");
